import Modal from "../common/Modal";
import TasksModalContent from "../Research/TasksModalContent";

// Headers for different types
const typeHeaders = {
    activityForm: "Plan activiteit in",
    measureMoment: "Plan meetmoment in",
}

const TasksModal = ({
  setModalOpen,
  modalOpen,
  type,
  adressID = '',
  personaID = '',
  measureMomentID = '',
  activityFormID = '',
  teamMemberID = '',
}) => {
  const pageHeader = typeHeaders[type] || "Plan taak in"

  return (
    <Modal
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      confirm={() => setModalOpen(false)}
      pageHeader={pageHeader}
      content={
        <TasksModalContent
          type={type}
          adressID={adressID}
          personaID={personaID}
          measureMomentID={measureMomentID}
          activityFormID={activityFormID}
          teamMemberID={teamMemberID}
        />
      }
    />
  )
};

export default TasksModal;
